<template>
  <section v-for="(data, index) in content" :key="index" class="main-container">
    <div class="section__container">
      <div
        :class="index % 2 === 0 ? 'odd sticky-sidebar' : 'even sticky-sidebar'"
      >
        <p class="sidebar-title" v-if="data.blackTitle">
          {{ data.blackTitle }}
        </p>
        <p class="sidebar-title accent-red" v-if="data.redTitle">
          {{ data.redTitle }}
        </p>
      </div>
      <div class="contents">
        <div class="line" />
        <div
          class="content__wrapper"
          v-for="(step, index) in data.steps"
          :key="index"
        >
          <keep-alive>
            <div class="content-icon-wrapper">
              <v-img
                :src="require(`@/assets/img/${step.icon}`)"
                class="content-icon"
              ></v-img>
            </div>
          </keep-alive>
          <div class="content-text-wrapper">
            <p class="content__step">{{ step.id }}</p>
            <p class="content__title">
              {{ step.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewMainContainer',
  data: () => ({
    content: [
      {
        blackTitle: 'How can you',
        redTitle: 'join our Talent Pool?',
        bgColor: '#fafafa',
        steps: [
          {
            id: 'Step 1',
            title: 'Screening Call with Our Talent Acquisition Team',
            icon: 'JP1.svg',
          },
          {
            id: 'Step 2',
            title: 'Technical skills assessment with our enablement team',
            icon: 'JP2.svg',
          },
          {
            id: 'Step 3',
            title: 'Communication skills and cultural fit assessment',
            icon: 'JP3.svg',
          },
          {
            id: 'Step 4',
            title:
              'Earn Verification Badges and officially join the Talent Pool',
            icon: 'JP4.svg',
          },
        ],
      },
      {
        blackTitle: 'How will you',
        redTitle: 'get onboarded?',
        bgColor: '#ffffff',
        steps: [
          {
            id: 'Step 1',
            title: 'Your Resume Shared With Relevant Clients',
            icon: 'JP5.svg',
          },
          {
            id: 'Step 2',
            title: 'Once Client Shows Interest We Schedule The Interview',
            icon: 'JP6.svg',
          },
          {
            id: 'Step 3',
            title: 'You Will Interview With The Client',
            icon: 'JP7.svg',
          },
          {
            id: 'Step 4',
            title:
              'Once Client Confirms Selection Then DIGU Reaches Out To You',
            icon: 'JP8.svg',
          },
          {
            id: 'Step 5',
            title: 'Onboarding Begins — You Start Working Through DIGU',
            icon: 'JP9.svg',
          },
        ],
      },
    ],
  }),
};
</script>

<style scoped>
.main-container {
  padding: 4rem 0;
  width: 100%;
  background-color: #f2f2f2;
}

.main-container:nth-child(even) {
  background-color: #fafafa;
}
.sidebar-title {
    font-family: 'Outfit Bold', sans-serif;
    font-size: clamp(28px, 5vw, 44px);
    text-align: left !important;
  }
.section__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.even-sidebar {
  background-color: #fafafa;
}

.sticky-sidebar {
  width: 100%;
  position: -webkit-sticky;
  position: sticky;
  top: 70px;
  /* height: 160px; */
  padding-block: 1rem;
  /* padding: 1rem; */
  /* background-color: var(--primary-color-lighten); */
  /* background: linear-gradient(
    var(--primary-color-lighten) 75%,
    transparent 99%
  ); */
  z-index: 999;
}

@media only screen and (min-width: 1024px) {
  .section__container {
    flex-direction: row;
  }
  .sticky-sidebar {
    width: 40%;
    top: 150px;
    height: 150px;
  }
  .contents {
    position: relative;
    width: 40%;
    display: flex;
    flex-direction: column;
    gap: 6rem;
  }
  .content__wrapper {
    width: 100%;
    display: flex;
    align-items: start;
    gap: 2rem;
    text-align: left;
  }

  .line {
    position: absolute;
    top: 4rem;
    left: 1.75rem;
    width: 4px;
    height: calc(100% - 150px);
    background-color: var(--primary-color);
    display: block;
  }

  
  .sidebar-description {
    text-align: left !important;
  }
}

.accent-red {
  color: var(--accent-red);
}

.sidebar-description {
  font-family: 'DM Sans Bold', sans-serif;
  font-size: 1rem;
  color: var(--light-1);
  text-align: center !important;
}

@media only screen and (max-width: 1024px) {
  .contents {
    position: relative;
    width: 75%;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin-top: 2rem;
    margin-inline: auto;
  }
  .line {
    display: none;
  }
  .content__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .sticky-sidebar {
    width: 100%;
  }
  .odd {
    background-color: #fafafa;
  }
  .even {
    background-color: #f2f2f2;
  }
  .sidebar-title {
    font-family: 'Outfit Bold', sans-serif;

    text-align: center !important;
    
  }
}

.content-icon-wrapper {
  width: 60px;
  height: 60px;
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: var(--primary-color);
  padding: 12px;
  margin-top: 1rem;
}
.content-icon {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.content__step {
  font-family: 'Outfit Semibold', sans-serif;
  font-size: 1.5rem;
  color: var(--primary-color);
}

.content__title {
  font-family: 'Outfit Semibold', sans-serif;
  font-size: clamp(1rem, 5vw, 1.75rem);
  line-height: 1.2;
  /* color: var(--light-1); */
}

.marquee-section {
  display: block;
  height: 50px;
  margin-block: 3rem;
  background-image: url('@/assets/img/LOGOS_1824x48_re.png');
  background-size: cover;
  background-repeat: repeat-x;
  animation: marquee 2400s linear infinite;
  z-index: 0;
}

@keyframes marquee {
  0% {
    background-position-x: 0;
  }

  100% {
    background-position-x: 100000px;
  }
}
</style>
